import { useTranslation } from 'react-i18next';
import { EmployeeNameColumn } from '@common';
import { RestrictedEmployee } from 'common/RestrictedEmployee';
import EmployeeOffboardedWarningIcon from '@/components/People/EmployeeOffboardedWarningIcon';
import EmployeeOnLeaveIcon from '@/components/People/EmployeeOnLeaveIcon';
import TableCellFlexContainer from 'common/Table/TableCellFlexContainer';
import { AssetAssignmentEmployee } from '@/types/assets';
import { EmployeeLeave } from '@/types/employees';

type AssetAssignedToCellProps = {
  employee: AssetAssignmentEmployee | undefined;
  /** The assignee is outside the user's divisions, so nothing about them is shown. */
  isRestricted?: boolean;
  leaves?: EmployeeLeave[];
  leavesLoading?: boolean;
};

const AssetAssignedToCell = ({
  employee,
  isRestricted,
  leaves,
  leavesLoading,
}: AssetAssignedToCellProps) => {
  const { t } = useTranslation('common');

  if (isRestricted) {
    return (
      <TableCellFlexContainer>
        <RestrictedEmployee tooltip={t('restrictedEmployee.assignedTooltip')} />
      </TableCellFlexContainer>
    );
  }

  if (!employee) {
    return null;
  }

  return (
    <TableCellFlexContainer>
      <EmployeeOffboardedWarningIcon employeeId={employee.id} />
      <EmployeeOnLeaveIcon
        employeeId={employee.id}
        leaves={leaves}
        leavesLoading={leavesLoading}
      />
      <EmployeeNameColumn
        firstName={employee.firstName}
        preferredFirstName={undefined}
        lastName={employee.lastName}
        email={null}
        employeeId={employee.id}
        hideAvatar
      />
    </TableCellFlexContainer>
  );
};

export default AssetAssignedToCell;
